import "@aws-amplify/ui-react/styles.css";
import React from "react";
import NotFound from "./NotFound";
import { LoadingBlock } from "../controls/LoadingBlock";
import { AnnotateImage } from "../controls/AnnotateImage";
import { getDescriptor } from "../clients/photo-upload-client";
import { ImageDescriptorData, RetriggerAllImages, RetriggerFile } from "../clients/data-service";
import { LoadingPage } from "../controls/LoadingPage";
import { Button } from "@chakra-ui/react";

class ReviewSubmission extends React.Component<{}, {liveDescriptor?: ImageDescriptorData}> {

    constructor(props) {
        super(props);
        this.state = {
        };
        
        const location = window.location;
        const paths = location.pathname.split('/');
        const imageId = paths[paths.length - 1];

        async function LoadDescriptor(comp) {
            const liveImageDesc = await getDescriptor(imageId);
            comp.setState(prev => {
                const newState = structuredClone(prev);
                newState.liveDescriptor = liveImageDesc;
                return newState;
            });
        }
        LoadDescriptor(this);
        this.rethumbnail = this.rethumbnail.bind(this);
    }

    async rethumbnail() {
        const descr = this.state.liveDescriptor;
        if (descr) {
            RetriggerFile(`Images/${descr.original_image}.jpg`);
            if (descr.public_image) {
                RetriggerFile(`Images/${descr.public_image}.jpg`);
            }
        }
        //RetriggerAllImages();
        
    }

    componentDidMount() {
        
    }
    render() {
        if (this.state.liveDescriptor == null) {
            return <LoadingPage pageTitle="Review Image" />;
        }

        if (this.state.liveDescriptor.id == null) {
            return <NotFound message="Image Not Found" />;
        }
        return (
            <>
            <AnnotateImage imageDescriptor={this.state.liveDescriptor} />
            <Button colorScheme="red" onClick={this.rethumbnail}>Re-Thumbnail</Button>
            </>
        );
    }
}

export default ReviewSubmission;